import { SimpleChanges } from '@angular/core'

export const enum ChangesStrategy {
  First = 'firstTime',
  Each = 'eachTime',
  NonFirst = 'nonFirst',
}

/** Track the changes of a given property and call the appropriate method
 * given a change strategy
 * @param { string } key the name of the prop
 * @param { string } methodName the method to call
 * @param { ChangesStrategy } strategy the strat to adopt
 */
export function TrackChanges<Type>(
  key: string,
  methodName: string,
  strategy: ChangesStrategy = ChangesStrategy.Each
): (
  targetClass: Type,
  propertyKey: string,
  descriptor: PropertyDescriptor
) => PropertyDescriptor {
  return function (
    targetClass: Type,
    propertyKey: string,
    descriptor: PropertyDescriptor
  ): PropertyDescriptor {
    const source = descriptor.value

    descriptor.value = function (changes: SimpleChanges): PropertyDescriptor {
      if (changes && changes[key] && changes[key].currentValue !== undefined) {
        const isFirstChange = changes[key].firstChange
        if (
          strategy === ChangesStrategy.Each ||
          (strategy === ChangesStrategy.First && isFirstChange) ||
          (strategy === ChangesStrategy.NonFirst && !isFirstChange)
        ) {
          targetClass[methodName].call(this, changes[key].currentValue as Type)
        }
      }
      return source.call(this, changes)
    }

    return descriptor
  }
}
